import { PaymentCategoryType } from 'consts';

function hasGroupedCardMethods(paymentMethodTypes: IPaymentMethod[]) {
  const cardMethod = paymentMethodTypes.filter((detail: IPaymentMethod) => detail.type === PaymentCategoryType.CARD);
  return cardMethod[0] ? cardMethod[0].paymentMethods.length > 1 : false;
}

function filterPaymentMethods(paymentMethods: IMethod[], selectedMethodId: string) {
  return paymentMethods.filter((method: IMethod) => {
    if (method.id !== selectedMethodId) return false;
    method.preSelected = true;
    return true;
  });
}

function filterGroupedCardMethods(paymentMethods: IMethod[], selectedMethodId: string) {
  return paymentMethods.filter((method: IMethod) => {
    if (method.id === selectedMethodId) method.preSelected = true;
    return true;
  });
}

function isSelectedGroupedCardMethod(hasGroupedCard: boolean, selectedPaymentMethodType: string) {
  return (
    hasGroupedCard &&
    (selectedPaymentMethodType === PaymentCategoryType.CLICK_TO_PAY ||
      selectedPaymentMethodType === PaymentCategoryType.CARD)
  );
}

export const filterIfHasSelectedPaymentMethod = (
  paymentMethodTypes: IPaymentMethod[],
  selectedPaymentMethodType?: string,
  selectedPaymentMethodId?: string
) => {
  if (selectedPaymentMethodType && selectedPaymentMethodId && paymentMethodTypes.length > 0) {
    let filterPaymentMethodsType: IPaymentMethod[] = JSON.parse(JSON.stringify(paymentMethodTypes));
    const hasGroupedCard = hasGroupedCardMethods(paymentMethodTypes);
    const searchPaymentMethodType =
      selectedPaymentMethodType === PaymentCategoryType.CLICK_TO_PAY && hasGroupedCard
        ? PaymentCategoryType.CARD
        : selectedPaymentMethodType;

    filterPaymentMethodsType = filterPaymentMethodsType.filter(
      (detail: IPaymentMethod) => detail.type === searchPaymentMethodType
    );

    filterPaymentMethodsType[0].paymentMethods = isSelectedGroupedCardMethod(hasGroupedCard, selectedPaymentMethodType)
      ? filterGroupedCardMethods(filterPaymentMethodsType[0]?.paymentMethods, selectedPaymentMethodId)
      : filterPaymentMethods(filterPaymentMethodsType[0]?.paymentMethods, selectedPaymentMethodId);

    return filterPaymentMethodsType;
  }
  return paymentMethodTypes;
};

export default filterIfHasSelectedPaymentMethod;
